/*
 *   File : user-detail.js
 *   Author URI : https://evoqins.com
 *   Description : User detail page
 *   Integrations : null
 *   Version : v1.1
 */

/* import packages */
import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Modal } from "bootstrap";

/* import components */
import { NavigationHeader } from "../../../Components/Header";
import { UserDetailSummary } from "../../../Components/Cards";
import { CustomTab } from "../../../Components/Tab";
import { BreadCrumb } from "../../../Components/Breadcrumb";
import { GradientButton, OutlineButton } from "../../../Components/Cta";
import { DeleteUser, NomineeOTPVerification, PhysicalApplyModal } from "../../../Components/Modal";
import { Icon } from "../../../Components/Icon";
/* import container */
import { CustomerProfile, MandateList, OrderList, Portfolio, RiskAssessment, SipHistory, SipList, Report, JointHolders, MinorDetail } from "./helper";
import { CustomLoader } from "../../../Components/Other";
import APIService from "../../../Services/api-service";
import FamilyDashboard from "./helper/family";

/* import styles */

const PAGE_NAVIGATION = [
    "Dashboard",
    "Users",
    "User details"
]

const TAB_DATA = [
    "Profile & KYC",
    "Portfolio",
    "Orders",
    "SIPs",
    "Mandates",
    "Risk-Assessment",
    // "SIP History",
    "Reports",
    "Manage Family"
]

const AdminUserDetail = React.memo(() => {

    const ADMIN_PROFILE_DATA = useSelector(state => state.MT_ADMIN_STORE.ADMIN_PROFILE);
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();
    const customerIdFromUrl = params["*"]; // "11964"
    const customerId = location.state?.user_id || customerIdFromUrl;
    const [tabIndex, setTabIndex] = useState(1);
    const [userData, setUserData] = useState({});
    const [summaryData, setSummaryData] = useState({});
    const [loader, setLoader] = useState(true);
    const [tabData, setTabData] = useState([]);
    const [syncing, setSyncing] = useState(false);
    const [showDeletedRed, setShowDeletedRed] = useState(false);
    const [openRemoveModal, setOpenRemoveModal] = useState(false);
    // const [permissionType, setPermissionType] = useState('');
    const [initialRender, setInitialRender] = useState(true);
    const [openPhysicalApplyModal, setOpenPhysicalApplyModal] = useState(false);
    const [showPinModal, setShowPinModal] = useState(false);
    const [otpPayload, setOtpPayload] = useState(null);
    const [otpLoader, setOtpLoader] = useState(false);

    const _resendCustomDematOTP = () => {
        if (!otpPayload) return;
        _sendCustomDematOTP(otpPayload);
    };


    useEffect(() => {
        if (openPhysicalApplyModal === true) {
            const modalEl = document.getElementById("physical-apply-modal");

            const modal = new Modal(modalEl, {
                backdrop: 'static',
                keyboard: false
            });

            modal.show();
        }
    }, [openPhysicalApplyModal]);


    useEffect(() => {
        if (showPinModal === true) {
            const modal = new Modal(document.getElementById("nominee-otp"), {});
            modal.show();
        }
    }, [showPinModal])

    useEffect(() => {
        if (initialRender === true)
            setInitialRender(false)
    }, [])

    // useEffect(() => {

    //         setPermissionType(page_type[0].action);
    //         setInitialRender(false)
    //     }
    // }, [ADMIN_PROFILE_DATA, location]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (initialRender === true) {
            setInitialRender(false);
        } else {
            _getUserSummary();
        }
    }, [initialRender]);

    // When redirecting back from MFC with success, switch to Portfolio tab so ExternalImportFileUploadModal can open
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const isSuccess = searchParams.get("status") === "success";
        const type = searchParams.get("type");
        const isMfcRedirect = type === "transactions" || type === "summary";
        if (isSuccess && isMfcRedirect) {
            setTabIndex(2);
        }
    }, [location.search]);

    useEffect(() => {
        return () => {
            setTabData([]);
        };
    }, []);

    useEffect(() => {
        if (location.state?.tabIndex !== undefined) {
            setTabIndex(location.state.tabIndex);
        }
    }, [location.state]);

    useEffect(() => {
        if (Object.keys(userData).length !== 0) {
            if (tabData.length === 0) {
                let tab = [...TAB_DATA];
                console.log('userData', userData.profile);
                if (userData.profile.minor_flag === true) {
                    tab.push('Guardian details');
                }
                if (userData.profile.account_type === 'Joint account') {
                    tab.push('Joint holders');
                }
                if (userData.profile.account_type === 'Anyone or Survivor') {
                    tab.push('Other holders');
                }
                if (userData.profile.account_type === 'Either or Survivor') {
                    tab.push('Other holders');
                }
                console.log('tab', tab);
                setTabData(tab);
            }
        }
    }, [userData]);

    useEffect(() => {
        if (customerId && initialRender === false) {
            _getUserData();
        }
        //eslint-disable-next-line
    }, [customerId, initialRender])



    const _handleTabIndex = (tab_index) => {
        setTabIndex(tab_index);


        navigation(location.pathname, {
            replace: true,
            state: {
                ...location.state,
                tabIndex: tab_index
            }
        });
    }

    function _closeRemoveModal() {
        setOpenRemoveModal(false);
    }

    function _navigateToKYC() {
        navigation('/create-account', {
            state: {
                user_id: customerId
            }
        })
    }

    // API - Get user data
    function _getUserData() {
        let url = 'user/profile/get';
        let payload = JSON.stringify({
            customer_id: customerId
        });
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                setUserData(response.data);
            }
            setLoader(false);
        })
    }


    // API - Get user summary
    function _getUserSummary() {
        let url = 'user/profile/summary';
        let payload = JSON.stringify({
            customer_id: customerId
        });
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                setSummaryData(response.data);
                setInitialRender(false);
            } else {
                setInitialRender(false);
            }
        })
    }

    // API - sync folios
    function _syncFolio() {
        setSyncing(true);
        let url = 'user/folio-sync';
        let payload = JSON.stringify({
            customer_id: customerId
        });
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                toast.success('Data synced successfully', {
                    type: 'success'
                });
                _getUserData();
            } else {
                toast.error(response.message, {
                    type: 'error'
                })
            }
            setSyncing(false);
        })
    }

    function _handleDelete() {
        let url = 'user/delete';
        let payload = JSON.stringify({
            customer_id: customerId
        });
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                toast.success('Successfully OTP send', {
                    type: 'success'
                });
                setOpenRemoveModal(true);
            } else {
                toast.error(response.message, {
                    type: 'error'
                })
            }
        })

    };


    // API - user reset
    // function _physicalApply() {
    //     setResetLoader(true);
    //     let url = 'user/reset';
    //     let is_post = true;
    //     let payload = {
    //         customer_id: customerId
    //     }
    //     APIService(is_post, url, payload).then((response) => {
    //         if (response.status_code === 200) {
    //             toast.dismiss();
    //             toast.success(response.message, {
    //                 type: 'success'
    //             });
    //             // _getUserData();
    //             navigation('/create-account', {
    //                 state: {
    //                     user_id: customerId
    //                 }
    //             })
    //         } else {
    //             toast.dismiss();
    //             toast.error(response.message, {
    //                 type: 'error'
    //             })
    //         }
    //         setResetLoader(false);
    //     })
    // };


    function _physicalApply() {
        setOpenPhysicalApplyModal(true);
    };

    const _verifyCustomDematOTP = async (otp) => {
        setOtpLoader(true);

        try {
            const response = await APIService(true, "kyc/custom-demat-update", {
                ...otpPayload,
                otp
            });

            if (response.status_code === 200) {
                toast.dismiss();
                toast.success("Physical apply completed successfully");
                setShowPinModal(false);
                _getUserData();
                return true;
            } else {
                toast.dismiss();
                toast.error(response.message);
                return false;
            }
        } finally {
            setOtpLoader(false);
        }
    };


    const _sendCustomDematOTP = async (payload) => {
        setOtpLoader(true);

        try {
            const response = await APIService(true, "kyc/custom-demat-otp", payload);

            if (response.status_code === 200) {
                toast.dismiss();
                toast.success("OTP sent successfully");
                return { success: true };
            }

            return {
                success: false,
                message: response.message
            };
        } catch (err) {
            return {
                success: false,
                message: err?.message || "Something went wrong"
            };
        } finally {
            setOtpLoader(false);
        }
    };

    return (
        <Fragment>
            <NavigationHeader
                title="User details" />
            {
                loader === true ?
                    <div className="row h-80vh">
                        <CustomLoader />
                    </div>
                    :
                    <div className="ps-4 pe-lg-5 pe-md-2 pe-2 padding-42px-top">
                        <div className="d-flex justify-content-between">
                            <BreadCrumb data={PAGE_NAVIGATION} />
                            {
                                // permissionType === 'write' && userData.profile.is_deleted !== true &&
                                <p className={`${showDeletedRed === true ? 'color-red' : 'color-primary-color'} line-height-16px e-poppins-regular e-font-14 cursor-pointer my-0  ms-3 position-relative h-fit-content `}
                                    onMouseEnter={() => {
                                        setShowDeletedRed(true);
                                    }}
                                    onMouseLeave={() => {
                                        setShowDeletedRed(false);
                                    }}
                                    onClick={() => {
                                        _handleDelete()
                                    }}>
                                    Delete user

                                    {/* <span className="e-tool-tip-container position-relative "
                                            data-tooltip-content="Delete selected"
                                            placement="bottom"
                                        > */}
                                    <Icon icon={showDeletedRed === true ? "delete-red" : 'delete'}
                                        size={24}
                                        className="ms-1" />
                                    {/* </span> */}
                                </p>
                            }

                        </div>
                        <div className="row">
                            <div className="col-12">
                                <UserDetailSummary
                                    basicInfo={userData.profile}
                                    summaryInfo={summaryData}
                                    updateDetail={_getUserData} />
                            </div>
                        </div>
                        <div className="row gx-0 padding-28px-top">
                            <div className="col-7 scrollbar-container overflow-auto white-space-nowrap">
                                <CustomTab data={TAB_DATA}
                                    index={tabIndex}
                                    onSelectTab={_handleTabIndex} />
                            </div>
                            {
                                tabIndex === 1 &&
                                <div className="col-5  d-flex justify-content-end gap-2 ">
                                    {
                                        userData.profile.is_deleted !== true && userData.profile.kyc_step <= 10 &&
                                        <GradientButton label={userData.profile.kyc_step <= 0 ? "Create KYC" : "Resume KYC"}
                                            onPress={_navigateToKYC}
                                            className="me-2" />
                                    }
                                    <GradientButton label="Sync data"
                                        onPress={_syncFolio}
                                        loading={syncing} />

                                    {
                                        userData.profile.is_reset === true && (
                                            <OutlineButton
                                                label="Physical Apply"
                                                onPress={_physicalApply}
                                            // loading={resetLoader}
                                            />
                                        )
                                    }
                                </div>
                            }

                        </div>
                        {
                            tabIndex === 1 ?
                                <CustomerProfile updateBankList={_getUserData} updateDetail={_getUserData} customer_info={userData}
                                    updateProfile={_getUserData} />
                                :
                                tabIndex === 2 ?
                                    <Portfolio customer_info={userData.profile} />
                                    :
                                    tabIndex === 3 ?
                                        <OrderList />
                                        :
                                        tabIndex === 4 ?
                                            <SipList /> :
                                            tabIndex === 5 ?
                                                <MandateList userBank={userData.profile.banks} />
                                                :
                                                tabIndex === 6 ?
                                                    <RiskAssessment />
                                                    // :
                                                    // tabIndex === 7 ?
                                                    //     <SipHistory userId={customerId} />
                                                    : tabIndex === 7 ?
                                                        <Report userId={customerId} />
                                                        :
                                                        tabIndex === 8 ?
                                                            <>
                                                                <FamilyDashboard userId={customerId} customer_info={userData.profile} />
                                                            </>
                                                            : tabIndex === 9 ?
                                                                <>
                                                                    {
                                                                        userData.profile.minor_flag === true ?
                                                                            <MinorDetail data={userData.profile} />
                                                                            :
                                                                            <JointHolders data={userData.profile} />
                                                                    }
                                                                </>
                                                                :
                                                                <JointHolders data={userData.profile} />


                        }

                    </div>
            }
            {
                openRemoveModal === true &&
                <DeleteUser userId={customerId}
                    close={_closeRemoveModal} />
            }

            {openPhysicalApplyModal && (
                <PhysicalApplyModal
                    nominee={userData.nominees.nominees}
                    skipNominee={userData.profile.skip_nominee}
                    show={openPhysicalApplyModal}
                    close={() => setOpenPhysicalApplyModal(false)}
                    customerId={customerId}
                    onOtpSuccess={() => setShowPinModal(true)}
                    handleOtpSend={async (payload) => {
                        setOtpPayload(payload);
                        return await _sendCustomDematOTP(payload);
                    }}
                />

            )}


            {showPinModal && (
                <NomineeOTPVerification
                    close={() => setShowPinModal(false)}
                    handleOTPSubmission={_verifyCustomDematOTP}
                    onResendOTP={_resendCustomDematOTP}
                    loader={otpLoader}
                />
            )}
        </Fragment>
    )
})

export default AdminUserDetail;